import clsx from "clsx";
import { HeaderCell } from "../HeaderCell/HeaderCell";
export const AccountNameColDef = {
    headerName: "Account Name",
    colId: "accountName",
    editable: true,
    pinned: "left" as const,
    width: 260,
    suppressSizeToFit: true,
    headerComponentParams: {
        innerHeaderComponent: HeaderCell,
    },
    suppressHeaderMenuButton: true,
    sortable: false,
    valueGetter: (params) => {
        return params.data.account?.accountName;
    },
};

export const AccountNameCellRenderer = ({
    accountName,
    isTentative,
    isDisabled,
}: {
    isTentative: boolean;
    isDisabled: boolean;
    accountName?: string | null;
}) => {
    if (!accountName)
        return (
            <div
                className={clsx(
                    "size-full",
                    isDisabled ? "cursor-default" : "cursor-pointer",
                )}
            />
        );

    return (
        <div
            className={clsx(
                "flex  size-full items-center justify-between",
                !isDisabled && !isTentative ? "opacity-100" : "opacity-50",
                isDisabled ? "cursor-default" : "cursor-pointer",
            )}
        >
            {accountName}
        </div>
    );
};
